import React, { useMemo, useState } from 'react';

const BUNDLES = [
  {
    id: 'starter_10',
    credits: 10,
    amount: 5,
    currency: 'USD',
    label: 'Starter',
    description: 'Good for trying the visualizer',
  },
  {
    id: 'value_25',
    credits: 25,
    amount: 11,
    currency: 'USD',
    label: 'Value Pack',
    description: 'Most popular for regular painters',
  },
  {
    id: 'pro_50',
    credits: 50,
    amount: 20,
    currency: 'USD',
    label: 'Pro Bundle',
    description: 'Best for studios and heavy usage',
  },
];

function formatCurrency(amount, currency = 'USD', locale = 'en-US') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount);
}

function makeIdempotencyKey(bundleId) {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return `${bundleId}-${window.crypto.randomUUID()}`;
  }
  return `${bundleId}-${Date.now()}`;
}

function PurchaseCreditsWidget({ onPurchase, isLoading, locale = 'en-US' }) {
  const [activeBundle, setActiveBundle] = useState(BUNDLES[1].id);

  const selectedBundle = useMemo(
    () => BUNDLES.find((bundle) => bundle.id === activeBundle) || BUNDLES[0],
    [activeBundle]
  );

  async function handlePurchase() {
    const idempotencyKey = makeIdempotencyKey(selectedBundle.id);
    await onPurchase({ bundleId: selectedBundle.id, idempotencyKey });
  }

  return (
    <section className="account-card" aria-labelledby="purchase-credits-title">
      <h2 id="purchase-credits-title">Buy Credits</h2>
      <p className="account-muted">Secure checkout via Stripe. Credits never expire.</p>
      <div className="bundle-grid" role="radiogroup" aria-label="Credit bundles">
        {BUNDLES.map((bundle) => (
          <button
            key={bundle.id}
            type="button"
            className={`bundle-card ${activeBundle === bundle.id ? 'selected' : ''}`}
            onClick={() => setActiveBundle(bundle.id)}
            role="radio"
            aria-checked={activeBundle === bundle.id}
          >
            <span className="bundle-name">{bundle.label}</span>
            <span className="bundle-credits">{bundle.credits} credits</span>
            <span className="bundle-price">{formatCurrency(bundle.amount, bundle.currency, locale)}</span>
            <span className="bundle-description">{bundle.description}</span>
          </button>
        ))}
      </div>
      <button
        type="button"
        className="account-primary-button"
        onClick={handlePurchase}
        disabled={isLoading}
        aria-busy={isLoading}
      >
        {isLoading ? 'Redirecting to payment gateway...' : `Continue with ${selectedBundle.label}`}
      </button>
    </section>
  );
}

export default PurchaseCreditsWidget;
